/**
 * For regular integer values
 */
export const FORMAT_INTEGER_OPTIONS = {
  notation: 'compact',
  compactDisplay: 'short',
} as const

/**
 * For regular decimal values
 */
export const FORMAT_DECIMAL_OPTIONS = {
  maximumFractionDigits: 7,
} as const

/**
 * For USD values above 1 billion
 */
export const FORMAT_USD_LARGE_OPTIONS = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
  notation: 'compact',
  compactDisplay: 'short',
} as const

/**
 * For USD values between 1000 and 1 billion
 */
export const FORMAT_USD_MEDIUM_OPTIONS = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
} as const

/**
 * For USD values below 1000
 */
export const FORMAT_USD_SMALL_OPTIONS = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
  trailingZeroDisplay: 'stripIfInteger',
} as const

/**
 * For USD values of zero
 * we use compact notation to show $0
 */
export const FORMAT_USD_ZERO_OPTIONS = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  notation: 'compact',
  compactDisplay: 'short',
} as const
